import React from 'react'
import { Stamp } from './style'

export default () => <Stamp>Oferta destaque</Stamp>
